
import { Component, Vue, Prop } from "vue-property-decorator";
import {
  PostAddSystem,
  GetSystemList,
  PatchSystem,
  GetPlanList,
  UploadFile,
} from "@/request/common";
import { GetIdArr } from "@/utils/base";
import MainHeader from "@/components/main-header.vue";
import NavLeft from "@/components/nav-left.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
  },
})
export default class Login extends Vue {
  private data: any = [];
  private ifShowEdit: any = false;
  private editData: any = {
    template_info: [],
  };
  private plans: any = [];

  private forceUpdate() {
    this.$forceUpdate();
  }
  private goEdit(item: any) {
    if (item) {
      this.editData = JSON.parse(JSON.stringify(item));
      this.ifShowEdit = true;
    } else {
      this.editData = {};
      this.ifShowEdit = true;
    }
  }
  private editSure() {
    if (!this.editData.name) {
      this.$message.warning("请输入系统名称");
      return;
    }
    if (!this.editData.logo) {
      this.$message.warning("请上传logo");
      return;
    }
    if (
      !this.editData.plan_info ||
      this.editData.plan_info.length == 0
    ) {
      this.$message.warning("请选择随访计划");
      return;
    }
    if (!this.editData.web_url) {
      this.$message.warning("请输入网址");
      return;
    }
    this.editData.plan = GetIdArr(this.editData.plan_info);
    if (this.editData.id) {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      PatchSystem(this, this.editData.id, this.editData, loading).then(
        (res: any) => {
          this.$message.success("保存成功");
          this.ifShowEdit = false;
          this.getList();
        }
      );
    } else {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      PostAddSystem(this, this.editData, loading).then((res: any) => {
        this.$message.success("保存成功");
        this.ifShowEdit = false;
        this.getList();
      });
    }
  }
  private preView(url: any) {
    window.open(url);
  }
  private getList() {
    const params: any = {
      params: {
        ordering: "create_datetime",
        limit: 100,
      },
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetSystemList(this, params, loading).then((res: any) => {
      this.data = res.data;
    });
  }
  private getPlansData() {
    const params: any = {
      params: {
        limit: 100,
      },
    };
    GetPlanList(this, params).then((res: any) => {
      this.plans = res.data;
    });
  }
  private upload(file: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    // form.append("type", "file");
    form.append("file", fileObj);
    UploadFile(this, form).then((res: any) => {
      this.editData.logo = res.data.file_url;
      this.$forceUpdate();
    });
  }
  private mounted() {
    this.getList();
    this.getPlansData();
  }
}
